import { Component } from 'react';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import moment from 'moment';
import DownwardsArrowComponent from '../../shared_components/DownwardsArrowComponent';

moment.locale('nl');

class SavingsOverviewRiskClassReductionRowComponent extends Component {
  render() {
    const {
      date,
      remainingDebt,
      interest,
      interestDiscount,
      gross,
      repayment,
      monthlyPayment,
      monthlyPaymentDiscount,
    } = this.props;

    let dutchMonth = moment(date).format('MMMM');
    dutchMonth = dutchMonth.charAt(0).toUpperCase() + dutchMonth.slice(1);

    return (
      <tr className="savings-container__table__discount">
        <td>{date.substr(0, 4)} ({dutchMonth})
        </td>
        <td>{numeral(remainingDebt).format('$ 0,00.')}</td>
        <td>{numeral(interest / 100).format('%0.00')}</td>
        <td>
          <div className="savings-container__table__discount__arrow__container">
            <DownwardsArrowComponent
              classNames={'savings-container__table__discount__arrow'}
            />
          </div>
          {numeral(interestDiscount / 100).format('%0.00')}
        </td>
        <td>{numeral(gross).format('$ 0,00.')}</td>
        <td>{numeral(repayment).format('$ 0,00')}</td>
        <td>{numeral(monthlyPayment).format('$ 0,00')}</td>
        <td>{numeral(monthlyPaymentDiscount).format('$ 0,00.00')}</td>
      </tr>
    );
  }
}

SavingsOverviewRiskClassReductionRowComponent.propTypes = {
  date: PropTypes.string,
  remainingDebt: PropTypes.number,
  interest: PropTypes.number,
  interestDiscount: PropTypes.number,
  gross: PropTypes.number,
  repayment: PropTypes.number,
  monthlyPaymentDiscount: PropTypes.number,
  monthlyPayment: PropTypes.number,
};

SavingsOverviewRiskClassReductionRowComponent.defaultProps = {
  date: '',
  remainingDebt: '',
  interest: '',
  interestDiscount: '',
  gross: '',
  repayment: '',
  monthlyPaymentDiscount: '',
  monthlyPayment: '',
};

export default SavingsOverviewRiskClassReductionRowComponent;
